import {
    GO_BACK_HOME,
    CHANGE_ROOM_TYPE,
    ROOM_TYPE,
    NEXT_LAYOUT,
    PREVIOUS_LAYOUT
} from '../actions/types'

const INITIAL_STATE = {
    gobackHome: true,
    layoutIndex: 0,
    changedRoomType: 0,
    selectedRoomType: 0
}

export default (state = INITIAL_STATE, action ) => {

    // console.log("------- Choose Layout Reducer --------")
    // console.log(action.payload)

    switch (action.type) {
        
        case GO_BACK_HOME:
            return { ...state, gobackHome: action.payload}

        case CHANGE_ROOM_TYPE:
            return { ...state, changedRoomType: action.payload }

        case NEXT_LAYOUT:
            return { ...state, layoutIndex: state.layoutIndex + action.payload }
        
        case PREVIOUS_LAYOUT:
            return { ...state, layoutIndex: state.layoutIndex - action.payload }
        
        case ROOM_TYPE:
            return { ...state, selectedRoomType: action.payload }
        
        default:
            return state
    }


}